import type { IconSvgObject } from './types';

const ChevronLastIcon: IconSvgObject = [
  ["path", { d: "M7 6L13 12L7 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 6V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronLastIcon;
